module.exports = __webpack_public_path__ + "img/GrayStar.0e2ded1c.svg";